/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Pending_SavedInputs */

const en_us2_today_pending_saved = /** @type {(inputs: Today_Pending_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your workout is saved on this device and will be sent when the connection is back.`)
};

const pt_br2_today_pending_saved = /** @type {(inputs: Today_Pending_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu treino está salvo neste aparelho e será enviado quando a conexão voltar.`)
};

const es_419_today_pending_saved = /** @type {(inputs: Today_Pending_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu entrenamiento está guardado en este dispositivo y se enviará cuando vuelva la conexión.`)
};

const pt_pt2_today_pending_saved = /** @type {(inputs: Today_Pending_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu treino está guardado neste dispositivo e será enviado quando a ligação voltar.`)
};

const fr_fr2_today_pending_saved = /** @type {(inputs: Today_Pending_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta séance est enregistrée sur cet appareil et sera envoyée au retour de la connexion.`)
};

const de_de2_today_pending_saved = /** @type {(inputs: Today_Pending_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Training ist auf diesem Gerät gespeichert und wird gesendet, sobald die Verbindung zurück ist.`)
};

const it_it2_today_pending_saved = /** @type {(inputs: Today_Pending_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo allenamento è salvato su questo dispositivo e verrà inviato quando torna la connessione.`)
};

/**
* | output |
* | --- |
* | "Your workout is saved on this device and will be sent when the connection is back." |
*
* @param {Today_Pending_SavedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_pending_saved = /** @type {((inputs?: Today_Pending_SavedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Pending_SavedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_pending_saved(inputs)
	if (locale === "es-419") return es_419_today_pending_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_today_pending_saved(inputs)
	if (locale === "fr-FR") return fr_fr2_today_pending_saved(inputs)
	if (locale === "de-DE") return de_de2_today_pending_saved(inputs)
	if (locale === "it-IT") return it_it2_today_pending_saved(inputs)
	return en_us2_today_pending_saved(inputs)
});
export { today_pending_saved as "today.pending_saved" }